export enum Handles {
  FAIL = -1,
  DEFAULT = 0,
  PASS = 1,
  TIME = 2,
}
